import { shortcodes } from "./shortcodes";

$(document).ready(function () {
  window.requireConsent = window.requireConsent || [];
  requireConsent.push(function () {
    shortcodes.load();
    shortcodes.expand();
  });
});
